import { render } from "./Boiler.vue?vue&type=template&id=0dfc7b18"
import script from "./Boiler.vue?vue&type=script&lang=js"
export * from "./Boiler.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__